module.exports = __webpack_public_path__ + "static/img/14.bc3989c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/14.jpg
// module id = y5bg
// module chunks = 0